export default __webpack_public_path__ + "static/media/globee_gold_2019.4c19a7b1.png";